<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';
import goals from '@/common/data/goals';

withDefaults(defineProps<{
  homepage?: boolean;
}>(), {
  homepage: true,
});
</script>

<template>
  <ContentContainer class="goals">
    <header class="goalsHeader">
      <h3>Open Methane aims to achieve the following goals</h3>
      <NuxtLink
        v-if="homepage"
        to="/about"
        class="pageLink headerLink"
      >
        About Us
      </NuxtLink>
    </header>
    <main class="goalsMain">
      <div
        v-for="(goal, idx) in goals"
        :key="`goal-${idx}`"
        class="goal"
        :class="!homepage && 'goalLight'"
      >
        <div class="subhead-primary numeral">
          0{{ idx + 1 }}
        </div>
        <div class="heading-4 goal-text">
          {{ goal }}
        </div>
      </div>
    </main>
    <NuxtLink
      v-if="homepage"
      to="/about"
      class="pageLink headerLinkMobile"
    >
      About Us
    </NuxtLink>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.goals {
  padding: var(--spacing-xl) 0;
  border-top: 0.1rem solid var(--colour-light-warm-grey);
  border-bottom: 0.1rem solid var(--colour-light-warm-grey);
}
.goalsHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-l);

  h3 {
    margin-bottom: 0;
  }
}
.goalsMain {
  @include screen.gridContainer();
  @include screen.respond(tablet) {
    display: block;
  }
}
.goal {
  padding: var(--spacing-ml) var(--spacing-m) var(--spacing-l);
  background-color: var(--colour-off-white);
  position: relative;

  @include screen.grid(3, 4, 4);

  .goal-text {
    line-height: 1.05;
    font-weight: 700;
  }
  .numeral {
    line-height: 1.05;
    margin-bottom: var(--spacing-ml);
    color: var(--colour-accent);
  }

  &:before {
    content: "";
    display: block;
    pointer-events: none;
    position: absolute;
    top: -0.8rem;
    left: 0;
    height: calc(100% + 1.6rem);
    width: 100%;
    border-left: 0.1rem solid var(--colour-warm-grey);
    border-right: 0.1rem solid var(--colour-warm-grey);
  }
  &:after {
    content: "";
    display: block;
    pointer-events: none;
    position: absolute;
    left: -0.8rem;
    top: 0;
    width: calc(100% + 1.6rem);
    height: 100%;
    border-top: 0.1rem solid var(--colour-warm-grey);
    border-bottom: 0.1rem solid var(--colour-warm-grey);
  }

  @include screen.respond(tablet) {
    margin-bottom: -0.1rem;
    display: flex;

    span {
      padding-right: var(--spacing-m);
    }
  }
}
.goalLight {
  background-color: #fff;
}
.headerLink {
  @include screen.respond(tablet) {
    display: none;
  }
}
.headerLinkMobile {
  display: none;
  width: 100%;
  margin-top: var(--spacing-l);

  @include screen.respond(tablet) {
    display: flex;
  }
}
</style>
